






















































































import Vue from 'vue'
import Component from "vue-class-component";
import LoginForm from '@/components/Auth/LoginForm.vue';
import axios from "axios";
import {localize} from "vee-validate";
import {getLocale} from '@/utils/data-helper'
import ForgotPasswordEmailForm from '@/components/Auth/ForgotPasswordEmailForm.vue';
import RegistrationEmailForm from '@/components/Auth/RegistrationEmailForm.vue';
import RegistrationCodeForm from '@/components/Auth/RegistrationCodeForm.vue';
import RegistrationForm from '@/components/Auth/RegistrationForm.vue';
import { Getter } from 'vuex-class';

@Component({
  components: {LoginForm, ForgotPasswordEmailForm, RegistrationEmailForm, RegistrationCodeForm, RegistrationForm}
})
export default class Login extends Vue {
  @Getter("config") config: any;

  private cardHidden = true;
  private InternetExplorer = false;
  private form = 'loginForm';
  private langs = ['ru', 'en']
  private email = ''
  private sitekey = '6LekyusoAAAAACXCJBBytf8N8QDLwr6idK18PJr8'

  private isProgress: boolean = false;
  private errorMessage = '';

  setForm(form: string) {
    this.form = form
  }

  setEmail(email: string) {
    this.email = email
  }

  progressChange(val: boolean) {
    this.isProgress = val
  }

  errorMessageChange(val: string) {
    this.errorMessage = val
  }

  get title() {
    return this.config.company + '<br>' + this.$t('auth.title')
  }

  browserLanguage(): void {
    if (!localStorage.getItem('locale')) {
      let language = window.navigator ? (window.navigator.language) : "ru";
      language = language.substr(0, 2).toLowerCase();
      localStorage.setItem("locale", language);
      this.$i18n.locale = language;
    }
    if (this.config.only_english) {
      this.setLocale('en')
    }
  }

  beforeMount() {
    setTimeout(this.showCard, 400);
  }

  showCard() {
    this.cardHidden = false;
  }

  created() {
    this.browserLanguage();
    const userAgent = navigator.userAgent.toLowerCase();
    if ((/mozilla/.test(userAgent) && !/firefox/.test(userAgent) && !/chrome/.test(userAgent) && !/safari/.test(userAgent) && !/opera/.test(userAgent)) || /msie/.test(userAgent))
      this.InternetExplorer = true;
  }

  setLocale($event: string) {
    this.$i18n.locale = $event;
    localize($event)
    localStorage.setItem('locale', $event)
    axios.defaults.headers["Request-Language"] = getLocale()
    document.title = this.$store.getters.config.company + '. ' + this.$t('auth.title')
  }

}
